import { DTOImportJobResponse } from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class ImportJobsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  get(designSystemId: string, versionId: string, jobId: string) {
    return this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/import-jobs/${jobId}`,
      DTOImportJobResponse
    );
  }
}
